export interface EnterForm {
  identificator?: string;
  cardNumber?: string;
}

export interface LoginForm {
  identificator: string;
  password: string;
}

export interface RegistrationOrRecoveryForm extends EnterForm {
  agreement?: boolean;
  smsCode?: string;
  confirm?: string;
  password?: string;
}

export interface PhoneNumberCheckForm extends EnterForm {
  smsCode?: string;
  phone?: string;
  snils?: string;
  password?: string;
  agreement?: boolean;
}

export interface PinCodeAuthenticationForm {
  pinCode: string;
}

export enum EsiaResponseType {
  Authorization = 'Authorization',
  Registration = 'Registration',
  NoCards = 'NoCards',
}
